import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'admin/reviews',
    loadComponent: () =>
      import('./pages/admin-reviews-list/admin-reviews-list').then(
        (m) => m.AdminReviewsList,
      ),
  },
  {
    path: 'admin/create-review',
    loadComponent: () =>
      import('./pages/admin-create-review/admin-create-review').then(
        (m) => m.AdminCreateReview,
      ),
  },
  {
    path: 'contact/reviews',
    loadComponent: () =>
      import('./pages/reviews/reviews').then((m) => m.Reviews),
  },
  {
    path: 'contact/submit-review',
    loadComponent: () =>
      import('./pages/submit-review/submit-review').then((m) => m.SubmitReview),
  },
  {
    path: '',
    loadComponent: () => import('./pages/home/home').then((m) => m.Home),
  },
];
